import React, { useState } from "react";
import './linkiKreatos.css'
import Header from "../elements/Header/Header";
import { API_URL } from "../constans/roles";

export default function UploadForm() {
  const [blocks, setBlocks] = useState([
    {
      reactId: 0,
      campaign: "",
      client: "",
      format: "",
      width: "",
      height: "",
      device: "desktop",
      file: null,
    },
  ]);

  const [load,setLoading] = useState(false)
  const [results, setResults] = useState([]);

  const handleChange = (index, field, value) => {
    const newBlocks = [...blocks];
    newBlocks[index][field] = value;

    if(field === "device" && value === "st_desktop") {
      newBlocks[index].width = 1920
      newBlocks[index].height = 1080
      newBlocks[index].format = "INTERSTITIAL.sticky (desktop)"
      
    } else if (field === "device" && value === "st_mobile") {
      newBlocks[index].width = 1080
      newBlocks[index].height = 1920
      newBlocks[index].format = "INTERSTITIAL.sticky (mobile)"
    }

    setBlocks(newBlocks);
  };

  const handleFileChange = (index, file) => {
    const newBlocks = [...blocks];
    newBlocks[index].file = file;
    setBlocks(newBlocks);
  };

  const handleDeleteBlock = (index) => {
    setBlocks(blocks.filter(block => block.reactId != index))
  }

  const addBlock = () => {
    setBlocks([
      ...blocks,
      {
        reactId: blocks.length,
        campaign: "",
        client: "",
        format: "",
        width: "",
        height: "",
        device: "desktop",
        file: null,
      },
    ]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Sprawdzenie, czy każdy blok ma plik
    for (let i = 0; i < blocks.length; i++) {
      if (!blocks[i].file) {
        alert(`Dodaj plik ZIP dla bloku nr ${i + 1}`);
        return;
      }

      if (!blocks[i].campaign) {
        alert(`Dodaj Nazwe kampanii`);
        return;
      }

      if (!blocks[i].client) {
        alert(`Dodaj klienta`);
        return;
      }

      if (!blocks[i].format) {
        alert(`Dodaj format`);
        return;
      }

      if (!blocks[i].width) {
        alert(`Dodaj szerokość`);
        return;
      }

      if (!blocks[i].height) {
        alert(`Dodaj wysokość`);
        return;
      }
    }


    setLoading(true)
    const dataToSend = blocks.map(({ campaign, client, format, width, height, device }) => ({
      campaign,
      client,
      format,
      width: parseInt(width, 10),
      height: parseInt(height, 10),
      device,
    }));

    const formData = new FormData();
    formData.append("data", JSON.stringify(dataToSend));

    blocks.forEach(({ file }) => {
      formData.append("zips", file);
    });

    try {
      const res = await fetch(API_URL+ "/api/linki/upload", {
        method: "POST",
        body: formData,
      });
      const json = await res.json();

      console.log(json)

      setLoading(false)
      setResults(json);
      setBlocks([])
    } catch (error) {
      alert("Coś poszło nie tak podczas wysyłania.");
      console.error(error);
    }
  };

  return (
    <div className="linki-kreator">
      <Header />
      <h2 className="linki-h2">Upload reklam HTML</h2>
      <form onSubmit={handleSubmit} className="linki-form">
        {blocks.map((block, idx) => (
          <fieldset key={idx} style={{ marginBottom: "20px", padding: "10px", border: "1px solid #ccc" }}>
            <legend>Reklama {idx + 1}</legend>
            <label>
              Kampania:
              <input
                type="text"
                value={block.campaign}
                onChange={e => handleChange(idx, "campaign", e.target.value)}
                required
              />
            </label>
            <br />
            <label>
              Klient:
              <input
                type="text"
                value={block.client}
                onChange={e => handleChange(idx, "client", e.target.value)}
                required
              />
            </label>
            <br />
            <label>
              Format:
              <input
                type="text"
                value={block.format}
                onChange={e => handleChange(idx, "format", e.target.value)}
                required
              />
            </label>
            <br />
            <label>
              Szerokość (px):
              <input
                type="number"
                min="1"
                value={block.width}
                onChange={e => handleChange(idx, "width", e.target.value)}
                required
              />
            </label>
            <br />
            <label>
              Wysokość (px):
              <input
                type="number"
                min="1"
                value={block.height}
                onChange={e => handleChange(idx, "height", e.target.value)}
                required
              />
            </label>
            <br />
            <label>
              Urządzenie:
              <select
                value={block.device}
                onChange={e => handleChange(idx, "device", e.target.value)}
              >
                <option value="desktop">Desktop</option>
                <option value="mobile">Mobile</option>
                <option value="display_mobile">Display Uniwersalny</option>
                <option value="display_desktop">Display Desktop</option>
                <option value="st_desktop">Sticky Desktop</option>
                <option value="st_mobile">Sticky Mobile</option>
                <option value="scroll">SCROLL.me</option>
              </select>
            </label>
            <br />
            <label>
              Plik ZIP:
              <input
                type="file"
                accept=".zip"
                onChange={e => handleFileChange(idx, e.target.files[0])}
                required
              />
            </label>
            <br/>
            <label>
              <button style={{backgroundColor:'var(--delete-color)'}} onClick={e => handleDeleteBlock(block.reactId)}>Usuń X</button>
            </label>
          </fieldset>
        ))}

        <div className="linki-btn-wrap">
        <button type="button" onClick={addBlock}>+ Dodaj kolejny element</button>
        <br />
        <button style={{backgroundColor:'var(--accept-color)',color:'black',fontWeight:900}} type="submit">Wyślij</button>
        </div>

      </form>

      <hr />

      {
        load && 
        <h1>Proszę czekać, kreacje są dodawane...</h1>
      }

      {results.length > 0 && (
        <div>
          <h3 className="linki-h3">Wygenerowane linki:</h3>
          <ul>
            {results.map(({ url, label }, i) => (
              <li key={i} className="linki-linki">
                <a href={url} target="_blank" rel="noreferrer">{url}</a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}